<!-- thanks to Alrik for the layout and footer code (borrowed from cvpnet-registration :-) ) -->
<template>
  <!-- indicates that the config is loading -->
  <v-app v-if="configurationOk == 0">
    <v-container style="height: 400px">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12"> {{ $t('common.loading_Config') }} </v-col>
        <v-col cols="6">
          <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

  <!-- configuration is ok -->
  <v-app v-else-if="configurationOk == 1">
    <v-main>
      <router-view class="fill-height" />
    </v-main>

    <Snackbar ref="snackbar" />
  </v-app>
  <!-- club has disabled HaKuBu -->
  <v-app v-else-if="configurationOk == 2">
    <v-container style="height: 400px">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-icon color="red" x-large>mdi-lock-alert-outline</v-icon>
        <v-col class="text-subtitle-1 text-center" cols="12"> {{ $t('errors.noHaKuBuForThisClub') }} </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
// Api
import { Api } from '@/api/apiAccess.ts';

// mixins
import HelpersMixin from '@/mixins/helpers.js';
import ConstantsMixin from '@/mixins/constants.js';
import snackbars from './mixins/snackbars.js';

// components
import Snackbar from '@/components/controls/Snackbar.vue';

export default {
  name: 'App',

  mixins: [HelpersMixin, ConstantsMixin],

  props: {
    clubId: String,
  },

  components: {
    Snackbar,
  },

  data: () => {
    return {
      configurationOk: 0,
    };
  },

  async mounted() {
    const cookieDisplayMode = this.getCookie(this.COOKIEKEY_DISPLAYMODE);
    if (cookieDisplayMode == null) {
      // if the cookie for the display mode is not set, check the users preferred color scheme and set it accordingly
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        // set display mode cookie (dark mode) forever
        this.setCookie(this.COOKIEKEY_DISPLAYMODE, this.COOKIEVAL_DISPLAYMODE_DARK, 0, true);
        this.$vuetify.theme.dark = true;
      } else {
        // set display mode cookie (light mode) forever
        this.setCookie(this.COOKIEKEY_DISPLAYMODE, this.COOKIEVAL_DISPLAYMODE_LIGHT, 0, true);
        this.$vuetify.theme.dark = false;
      }
    } else {
      if (cookieDisplayMode === this.COOKIEVAL_DISPLAYMODE_DARK) {
        this.$vuetify.theme.dark = true;
      } else if (cookieDisplayMode === this.COOKIEVAL_DISPLAYMODE_LIGHT) {
        this.$vuetify.theme.dark = false;
      } else {
        // default/fallback is light mode
        this.$vuetify.theme.dark = false;
        this.setCookie(this.COOKIEKEY_DISPLAYMODE, this.COOKIEVAL_DISPLAYMODE_LIGHT, 0, true);
      }
    }

    if (this.$route.params.clubId) {
      /*
       * If a club number has been specified, it must first be checked whether this club number is assigned to a club.
       * The easiest way to do this is to use the HaKuBuController.ClubLogin function, because before checking the password, the database of the club must be determined
       *
       * If this API call returns the error code -2, the CVPnet Buchung knows that the given number is not assigned to a club and can display the 404 page
       * Because it is only about checking whether the club number is assigned to a club, only the club number must be passed (the other parameters can be garbaged).
       * In addition, other error codes are ignored.
       *
       * This was introduced because the call to GetConfig() throws an error if the club number does not exist
       */

      try {
        var clubLoginViewModel = { VereinsNummer: this.$route.params.clubId, Passwort: 'superSecurePassword' };
        var clubNumberExists = (await Api.HaKuBu.haKuBuVereinsLogin(clubLoginViewModel)).data.LoginId != -2;
      } catch (error) {
        this.$root.snackbar.show(this.$root.snackbars.genericError);
        this.configurationOk = 1;
        return;
      }

      if (!clubNumberExists) {
        this.configurationOk = 1;
        // wait 2 ticks for snackbars to be added to root
        await this.$nextTick();
        await this.$nextTick();
        // show snackbar and navigate to ClubNotFoundView
        this.$root.snackbar.show(this.$root.snackbars.clubNumNotFound(this.$route.params.clubId));
        this.$router.push({ name: 'ClubNotFound' });
        // delete clubnumber in cookies
        this.deleteCookie(this.COOKIEKEY_LASTCLUBNUM);
        return;
      }

      try {
        var configData = (await Api.HaKuBu.haKuBuGetConfig(this.$route.params.clubId)).data;
      } catch (error) {
        this.$root.snackbar.show(this.$root.snackbars.genericError);
        this.configurationOk = 1;
        return;
      }

      // store clubnumber forever in cookies
      this.setCookie(this.COOKIEKEY_LASTCLUBNUM, this.$route.params.clubId, 0, true);

      if (configData.HaKuBuAktivieren) {
        this.configurationOk = 1;
      } else {
        this.configurationOk = 2;
        return;
      }
    }
    this.configurationOk = 1;
  },

  watch: {
    async configurationOk(newVal) {
      this.$root.snackbar = undefined;
      this.$root.snackbars = undefined;

      if (newVal == 1) {
        await this.$nextTick();
        this.$root.snackbar = this.$refs.snackbar;
        this.$root.snackbars = snackbars;
      }
    },
  },
};
</script>

<style scoped>
.v-application--wrap {
  height: 100vh !important;
}

html {
  overflow-y: auto;
}
</style>
